import React from "react";

interface VideoMessageProps {
  url: string;
  prompt?: string;
}

export const VideoMessage: React.FC<VideoMessageProps> = ({ url, prompt }) => {
  return (
    <div className="rounded-lg border border-border p-3">
      <video controls className="w-full rounded">
        <source src={url} />
      </video>
      {prompt && (
        <p className="text-xs text-muted-foreground mt-2">“{prompt}”</p>
      )}
    </div>
  );
};
